import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { Coach } from "../../common/models/coach";
import { OrganizationRole } from "../../common/models/organization-role";
import { User } from "../../common/models/user";
import { Team } from "../../common/models/team";
import { CoachTeam } from "../../common/models/coach-team";
import { AthleteTeam } from "../../common/models/athlete-team";
import { Athlete } from "../../common/models/athlete";
import { Guest } from "../../common/models/guest";
import { GuestTeam } from "../../common/models/guest-team";

export class TeamRights {
  public Ready: Promise<boolean> = new Promise<boolean>((resolve, reject) => {});
    private _itemRightsList: TeamItemRightsList | null = null;
    private _screenRightsList: TeamScreenRightList | null = null;
    private _paramsItem: TeamItemRightsParams | null = null;
    private _paramsScreen: TeamScreenRightsParams | null = null;
    private _bestOfItemRight = 10000;
    private _bestOfScreenRight = 10000;
    constructor(private _utils: UtilsProvider) {
        this.setDefault();
    }

    public evaluateItemRight(params: TeamItemRightsParams): void {

        /**
         * Les paramètres reçus contiennent le team, le user.id
         * et le organizationId. Les droits évalués doivent répondrent
         * à la question : qu'est-ce que je (user.id) peux faire avec
         * cette team (team.id) dans cette organisation (organizationId)
         * avec mon rôle (this._bestOfItemRight).
         */

        this._paramsItem = params;
        this.setDefault();
        this.setBestOfRole();

        const team = this._paramsItem.team;
        let userIds: number[];
        let coachIds: number[];
        let coaches: Coach[];

        if (!this._itemRightsList) return;

        switch (this._bestOfItemRight) {
        case OrganizationRole.ID_ADMIN:
            // this._paramsItem.user est un admin
            // toutes les teams
            this._itemRightsList.view = true;
            this._itemRightsList.edit = true;
            this._itemRightsList.delete = true;
            this._itemRightsList.changeCoaches = true;
            this._itemRightsList.changeAthletes = true;
            break;

        case OrganizationRole.ID_SUPERCOACH:
            // this._paramsItem.user est un supercoach
            // toutes les teams de son organisation
            this._itemRightsList.view = (team.organizationId === this._paramsItem.organizationId);
            this._itemRightsList.edit = (team.organizationId === this._paramsItem.organizationId);
            this._itemRightsList.delete = (team.organizationId === this._paramsItem.organizationId);
            this._itemRightsList.changeCoaches = this._itemRightsList.edit;
            this._itemRightsList.changeAthletes = this._itemRightsList.edit;
            break;

        case OrganizationRole.ID_COACH:
            // this._paramsItem.user est un coach
            // toutes les teams dont il est membre
            const mbsCoachs = this._utils.findManyIn([team.id], this._paramsItem.teamCoachRelations, 'teamId');
            coachIds = this._utils.getKeyValues(mbsCoachs, 'coachId');
            coaches = this._utils.findManyIn(coachIds, this._paramsItem.coaches, 'id');
            userIds = this._utils.getKeyValues(coaches, 'userId');

            if (userIds.indexOf(this._paramsItem.user.id ?? -1) > -1) {
                this._itemRightsList.view = true;
            }
            break;

            /**
             * L'athlète ne peut pas voir les teams :
             * https://app.clickup.com/t/28ftvg
             */
            // case OrganizationRole.ID_ATHLETE:
            //     // this._paramsItem.user est un athlète
            //     // toutes les teams dont il est membre
            //     const mbsAthletes = this._utils.findManyIn([team.id], this._paramsItem.teamAthleteRelations, 'teamId');
            //     const athleteIds = this._utils.getKeyValues(mbsAthletes, 'athleteId');
            //     const athletes = this._utils.findManyIn(athleteIds, this._paramsItem.athletes, 'id');
            //     userIds = this._utils.getKeyValues(athletes, 'userId');
            //
            //     if (userIds.indexOf(this._paramsItem.user.id) > -1) {
            //         this._itemRightsList.view = true;
            //     }
            //     break;

        case OrganizationRole.ID_GUEST:
            // this._paramsItem.user est un invité
            // idem que le coach mais en lecture seule
            const mbsGuests = this._utils.findManyIn([team.id], this._paramsItem.teamGuestRelations, 'teamId');
            const guestIds = this._utils.getKeyValues(mbsGuests, 'guestId');
            const guests = this._utils.findManyIn(guestIds, this._paramsItem.guests, 'id');
            userIds = this._utils.getKeyValues(guests, 'userId');

            if (userIds.indexOf(this._paramsItem.user.id ?? -1) > -1) {
                this._itemRightsList.view = true;
            }
            break;

        default:
            // rien
        }
    }

    public evaluateScreenRights(params: TeamScreenRightsParams): void {

        /**
         * Détermine les droits que l'utilisateur possède
         * pour les commandes générales des écrans.
         */

        this._paramsScreen = params;
        this.setDefault();
        this.setBestOfRole();

        if (!this._screenRightsList) return;

        switch (this._bestOfScreenRight) {
        case OrganizationRole.ID_ADMIN:
            // this._paramsItem.user est un admin
            this._screenRightsList.list = true;
            this._screenRightsList.add = true;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = true;
            break;

        case OrganizationRole.ID_SUPERCOACH:
            // this._paramsItem.user est un super-coach
            this._screenRightsList.list = true;
            this._screenRightsList.add = true;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = true;
            break;

        case OrganizationRole.ID_COACH:
            // this._paramsItem.user est un coach
            this._screenRightsList.list = true;
            this._screenRightsList.add = true;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = false;
            break;

            /**
             * L'athlète ne peut pas voir les teams :
             * https://app.clickup.com/t/28ftvg
             */
            // case OrganizationRole.ID_ATHLETE:
            //     // this._paramsItem.user est un athlète
            //     this._screenRightsList.list = true;
            //     this._screenRightsList.add = false;
            //     this._screenRightsList.edit = false;
            //     this._screenRightsList.delete = false;
            //     break;

        case OrganizationRole.ID_GUEST:
            // this._paramsItem.user est un invité
            this._screenRightsList.list = true;
            this._screenRightsList.add = false;
            this._screenRightsList.edit = false;
            this._screenRightsList.delete = false;
            break;

        default:
            // rien
        }
    }

    public getItemRightsList(): TeamItemRightsList {
      if (!this._itemRightsList) throw new Error('Item rights list is not defined');

      return this._itemRightsList;
    }

    public getScreenRightsList(): TeamScreenRightList {
      if (!this._screenRightsList) throw new Error('Screen rights list is not defined');

      return this._screenRightsList;
    }

    public getItemParams(): TeamItemRightsParams {
      if (!this._paramsItem) throw new Error('Item params is not defined');

      return this._paramsItem;
    }

    public getScreenParams(): TeamScreenRightsParams {
      if (!this._paramsScreen) throw new Error('Screen params is not defined');

      return this._paramsScreen;
    }

    public get LIST() {
        if (this._screenRightsList) {
            return this._screenRightsList.list;
        }
        return false;
    }

    public get ADD() {
        if (this._screenRightsList) {
            return this._screenRightsList.add;
        }
        return false;
    }

    public get EDIT() {
        if (this._screenRightsList) {
            return this._screenRightsList.edit;
        }
        return false;
    }

    public get DELETE() {
        if (this._screenRightsList) {
            return this._screenRightsList.delete;
        }
        return false;
    }

    private setDefault(): void {

      this._itemRightsList = {
          view: false,
          edit: false,
          delete: false,
          changeCoaches: false,
          changeAthletes: false,
        };

      this._screenRightsList = {
          list: false,
          add: false,
          edit: false,
          delete: false,
        };

        this._bestOfItemRight = 10000;
        this._bestOfScreenRight = 10000;
    }

    private setBestOfRole() {

        if (this._paramsItem && this._paramsItem.rolesIds.length > -1) {
            for (let i = 0; i < this._paramsItem.rolesIds.length; i++) {
                if (this._paramsItem.rolesIds[i] < this._bestOfItemRight) {
                    this._bestOfItemRight = this._paramsItem.rolesIds[i];
                }
            }
        }

        if (this._paramsScreen && this._paramsScreen.rolesIds.length > -1) {
            for (let i = 0; i < this._paramsScreen.rolesIds.length; i++) {
                if (this._paramsScreen.rolesIds[i] < this._bestOfScreenRight) {
                    this._bestOfScreenRight = this._paramsScreen.rolesIds[i];
                }
            }
        }
    }
}

export interface TeamItemRightsList {
    view: boolean;
    edit: boolean;
    delete: boolean;
    changeCoaches: boolean;
    changeAthletes: boolean;
}

const defaultRights: TeamItemRightsList = {
    view: false,
    edit: false,
    delete: false,
    changeCoaches: false,
    changeAthletes: false,
}

export function mapTeamRightsToRowRights(teamRights: string []): TeamItemRightsList {
    const rights = { ...defaultRights };

    teamRights.forEach((right: string) => {
        if (right in rights) {
            rights[right as keyof TeamItemRightsList] = true;
        }
    });

    return rights;
}

export interface TeamScreenRightList {
    list: boolean;
    add: boolean;
    edit: boolean;
    delete: boolean;
}

export interface TeamItemRightsParams {
    user: User;
    organizationId: number;
    team: Team;
    rolesIds: number[];
    teamCoachRelations: CoachTeam[];
    teamAthleteRelations: AthleteTeam[];
    teamGuestRelations: GuestTeam[];
    teams: Team[];
    coaches: Coach[];
    athletes: Athlete[];
    guests: Guest[];
}

export interface TeamScreenRightsParams {
    rolesIds: number[];
}
